import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
var SET_BASE_URL = 'SET_BASE_URL';
export default SET_BASE_URL;